module.exports = __webpack_public_path__ + "assets/img/923035.09fc9025.jpg";